import { styled } from '@mui/material';

export const DialogImportCustomersFromCSVImportErrorsDetailContainer = styled(
  'div',
)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const DialogImportCustomersFromCSVImportErrorsDetailControls = styled(
  'div',
)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));

export const DialogImportCustomersFromCSVImportErrorsDetailFilters = styled(
  'div',
)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  flexWrap: 'wrap',
  flex: 1,
}));

export const DialogImportCustomersFromCSVImportErrorsDetailGroups = styled(
  'div',
)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  maxHeight: 320,
  overflowY: 'auto',
}));

export const DialogImportCustomersFromCSVImportErrorsDetailEmpty = styled(
  'div',
)(({ theme }) => ({
  padding: theme.spacing(2),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));
